import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SecurityService } from '@core/security/security.service';
import { TranslationService } from '@core/services/translation.service';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { BaseComponent } from 'src/app/base.component';
import { UserService } from '../user.service';
import { ActivatedRoute } from '@angular/router';
import { CommonError } from '@core/error-handler/common-error';

@Component({
  selector: 'app-salesrepspasswordchange',
  templateUrl: './salesrepspasswordchange.component.html',
  styleUrls: ['./salesrepspasswordchange.component.scss'],
})
export class SalesrepspasswordchangeComponent
  extends BaseComponent
  implements OnInit
{
  changePasswordForm: UntypedFormGroup;
  isLoading = false;
  fieldTextType: boolean = false;
  constructor(
    private userService: UserService,
    private fb: UntypedFormBuilder,
    private toastrService: ToastrService,
    private securityService: SecurityService,
    public translationService: TranslationService,
    private route: ActivatedRoute
  ) {
    super(translationService);
  }

  ngOnInit(): void {
    this.createChangePasswordForm();
    const email = this.route.snapshot.queryParams['email'];
    this.changePasswordForm.patchValue({
      email: email,
    });
  }

  createChangePasswordForm() {
    this.changePasswordForm = this.fb.group(
      {
        email: [],
        oldPasswordPassword: ['', [Validators.required]],
        password: ['', [Validators.required, Validators.minLength(6)]],
        confirmPassword: ['', [Validators.required, Validators.minLength(6)]],
      },
      { validator: this.checkPasswords }
    );
  }

  checkPasswords(group: UntypedFormGroup) {
    let pass = group.get('password').value;
    let confirmPass = group.get('confirmPassword').value;
    return pass === confirmPass ? null : { notSame: true };
  }

  changePassword() {
    if (this.changePasswordForm.valid) {
      this.sub$.sink = this.userService
        .generatenewPassword(this.createBuildObject())
        .subscribe(
          (d: any) => {
            if (
              d?.isPasswordGenerated == null ||
              d.isPasswordGenerated === ''
            ) {
              this.toastrService.success(
                'New password generated successfully.'
              );
              this.securityService.logout();
            } else {
              this.toastrService.error(d?.isUserValid);
            }
            this.isLoading = false;
          },
          (err: CommonError) => {
            this.isLoading = false;
            if (err.messages) {
              err.messages.forEach((msg) => {
                this.toastrService.error(msg);
              });
            } else if (err.error) {
              this.toastrService.error(err.error as string);
            }
          }
        );
    }
  }

  createBuildObject() {
    return {
      email: '',
      oldPassword: this.changePasswordForm.get('oldPasswordPassword').value,
      newPassword: this.changePasswordForm.get('password').value,
      userName: this.changePasswordForm.get('email').value,
    };
  }
  onNoClick(): void {
    // this.dialogRef.close();
  }
}

@NgModule({
  declarations: [SalesrepspasswordchangeComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatProgressSpinnerModule,
    TranslateModule,
  ],
})
export class SalesRepsPasswordChangeModule {}
